<template>
  <!-- 人事  -->
  <div class="second-page-wrapper">
    <div class="second-page-wrapper-left">
      <common-slide :slideList="titleList"></common-slide>
    </div>
    <div class="second-page-wrapper-right">
      <router-view></router-view>
    </div>
  </div>
</template>
<style scoped>
.second-page-wrapper {
  width: 1230px;
  margin: 0 auto 30px;
  display: flex;
}
.second-page-wrapper-left{
   width: 310px;
  margin-right: 30px;
}
.second-page-wrapper-right{
  width: 890px;
}
</style>

<script>
import commonSlide from "./../common/slide.vue";
export default {
  data() {
    return {
      titleList: [
        {
          title: "党建专题",
          routerName: "brecruitment"
        }
      ]
    };
  },
  components: {
    commonSlide
  }
};
</script>



// WEBPACK FOOTER //
// src/components/views/BuildingList/index.vue